// extracted by mini-css-extract-plugin
export var button = "v_5";
export var buttonContent = "v_bL";
export var buttonInner = "v_bc";
export var loading = "v_bK";
export var loadingContainer = "v_bM";
export var loadingSpinner = "v_j";
export var loadingText = "v_l";
export var spin = "v_k";